import { Cog, Sparkles, ShieldCheck, HeartHandshake } from "lucide-react";

const ITEMS = [
  { icon: Cog, title: "We run what we build", body: "The team that ships your platform is the team that keeps it running. One accountability line." },
  { icon: Sparkles, title: "AI where it earns its place", body: "We use AI when it removes real work. We do not use it to look modern." },
  { icon: ShieldCheck, title: "Compliance is designed in", body: "PDPL, ISO controls and audit trails go in from sprint one — not bolted on before an audit." },
  { icon: HeartHandshake, title: "We do not disappear", body: "Written SLAs. Named engineers. No vanishing act after go-live." },
];

export function WhyChooseUs() {
  return (
    <section data-testid="why-choose-us-section" className="bg-white">
      <div className="mx-auto max-w-7xl px-4 py-20 lg:px-6 lg:py-28">
        <div className="max-w-3xl">
          <div className="text-xs font-semibold uppercase tracking-widest text-wafa-primary">Why choose us</div>
          <h2 className="mt-3 font-heading text-3xl font-semibold tracking-tight text-wafa-deep sm:text-4xl lg:text-5xl">
            Four things we will not compromise on.
          </h2>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2">
          {ITEMS.map(({ icon: Icon, title, body }) => (
            <div
              key={title}
              data-testid={`why-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="flex items-start gap-5 rounded-lg border border-wafa-deep/10 bg-white p-6 transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(14,79,58,0.2)]"
            >
              <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-wafa-deep text-white">
                <Icon className="h-5 w-5" />
              </div>
              <div>
                <div className="font-heading text-xl font-semibold text-wafa-deep">{title}</div>
                <p className="mt-2 text-sm leading-relaxed text-wafa-ink/75 lg:text-base">{body}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
